import { Box, Dialog, IconButton, Typography } from "@mui/material"
import { isAte, isMobile } from "utils/Global"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import CloseIcon from "@mui/icons-material/Close"

type InfoDialogProps = {
  showInfo: string | null
  setShowInfo: (value: string | null) => void
  title: string
  children: React.ReactNode
}

export default function InfoDialog(props: InfoDialogProps) {
  const { showInfo, setShowInfo, title, children } = props
  return (
    <Dialog
      open={showInfo !== null}
      onClose={() => setShowInfo(null)}
      maxWidth={false}
    >
      <IconButton
        size="large"
        aria-label="close"
        onClick={() => setShowInfo(null)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <Box
        sx={{
          padding: isMobile ? "16px" : "36px 70px",
          width: "960px",
          maxWidth: "100%",
          fontFamily: isAte ? "Etelka Light" : "ContinentalStagSans-Light",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            marginBottom: "16px",
            alignItems: "center",
          }}
        >
          <InfoOutlinedIcon
            fontSize={isMobile ? "small" : "large"}
            color="inherit"
          />
          <Typography
            sx={{
              fontSize: isMobile ? "16px" : "22px",
              fontWeight: "500",
              lineHeight: "24px",
              marginLeft: "5px",
            }}
          >
            {title}
          </Typography>
        </Box>
        {children}
      </Box>
    </Dialog>
  )
}
